import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TreeView from '../TreeView';
import { changeNavigationNodeState, sendAnalyticsEvent } from '../../src/actions/reports';
import { clickLeftNavigation } from '../../src/analyticsEvents';

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    nodes: state.reports.navigationBar,
  };
}

const mapDispatchToProps = dispatch => ({
  handleClick: (node) => {
    dispatch(changeNavigationNodeState(node));
    dispatch(sendAnalyticsEvent(clickLeftNavigation(node.title)));
  },
});

const LeftHandNav = connect(mapStateToProps, mapDispatchToProps)(TreeView);

LeftHandNav.propTypes = {
  onTabChange: PropTypes.func,
};

export default LeftHandNav;
